import conn from "@/store/utils/connection";
import snapMesinAPI from "@/store/utils/api-route/snapMesinAPI";
import resulter from "@/store/utils/resulter";
import state from "./state";
import api from "@/modules/kampus/apiEndPoint";

const actions = {
  async fetchListSnapMesin({ commit, rootGetters }, queryParam) {
    try {
      let filter = rootGetters["filterGlobalModule/getFilter"];
      let filterItem = rootGetters["filterGlobalModule/getFilterItem"];
      if (queryParam.idoutlet) {
        filterItem.idoutlet_snap = queryParam.idoutlet;
      }
      let query = {
        idoutlet: queryParam.idoutlet === undefined ? filterItem.idoutlet_snap : queryParam.idoutlet,
        idconsole: queryParam.idconsole,
        offset: state.pagination.offset,
        limit: state.pagination.limit,
        jenis_mesin:
          filterItem.jenisMesin.length > 0 ? filterItem.jenisMesin : 0,
        sensor_pintu:
          filterItem.sensorPintu.length > 0 ? filterItem.sensorPintu : 0,
        status_mesin:
          filterItem.statusMesin.length > 0 ? filterItem.statusMesin : 0,
        status_online:
          filterItem.statusKoneksi.length > 0 ? filterItem.statusKoneksi : 0,
        status_pintu:
          filterItem.statusPintu.length > 0 ? filterItem.statusPintu : 0,
        key: state.searchKey,
      };
      if (filter.sortBy !== "") {
        query.sort_by = filter.sortBy;
        query.order_by = filter.orderBy;
      }
      if (filterItem.kategoriMesin.length > 0) {
        query.kategori_mesin = filterItem.kategoriMesin;
      }

      const res = await conn.get(snapMesinAPI.list, query);
      if (!res.data) {
        throw res;
      }
      if (res.data.status) {
        await conn.setQueryString(query);
        commit("setListSnapMesin", res.data);
        return resulter.successResult();
      }
    } catch (e) {
      return resulter.errorResult(e);
    }
  },

  async fetchReportConnectionMesin({ commit, rootGetters }, queryParam) {
    try {
      let filterItem = rootGetters["filterGlobalModule/getFilterItem"];
      if (queryParam.idoutlet) {
        filterItem.idoutlet_snap = queryParam.idoutlet;
      }
      let query = {
        idoutlet: queryParam.idoutlet === undefined ? filterItem.idoutlet_snap : queryParam.idoutlet,
        idconsole: queryParam.idconsole,
      };
      const res = await conn.get(snapMesinAPI.connectionReport, query);
      if (!res.data) {
        throw res;
      }
      if (res.data.status) {
        commit("setReportConnectionMesin", res.data);
        return resulter.successResult();
      }
    } catch (e) {
      return resulter.errorResult(e);
    }
  },

  async fetchLatestVersionMesin({ commit }) {
    try {
      const res = await conn.get(snapMesinAPI.lastestVersionMesin);
      if (!res.data) {
        throw res;
      }
      if (res.data.status) {
        commit("setLatestVerionMesin", res.data);
        return resulter.successResult();
      }
    } catch (e) {
      return resulter.errorResult(e);
    }
  },

  async fetchLayananByAid({ commit, rootGetter }, aid) {
    try {
      let query = {
        aid: aid,
      };
      const res = await conn.get(snapMesinAPI.layananByAid, query);
      if (!res.data) {
        throw res;
      }
      if (res.data.status) {
        commit("setLayananByAid", res.data);
        return resulter.successResult(res.data.msg, res.data.data);
      }
    } catch (e) {
      return resulter.errorResult(e);
    }
  },

  async fetchDetailMesin({ commit, rootGetter }, queryParam) {
    try {
      let query = {
        idoutlet: queryParam.idoutlet,
        idsnap_mesin: queryParam.idsnap_mesin,
      };
      const res = await conn.get(snapMesinAPI.detailMesin, query);
      if (!res.data) {
        throw e;
      }
      if (res.data.status) {
        commit("setDetailMesin", res.data);
        return resulter.successResult();
      }
    } catch (e) {
      return resulter.errorResult(e);
    }
  },

  async fetchTagMesin({ commit, rootGetter }, idoutlet) {
    try {
      let query = {
        idoutlet: idoutlet,
      };
      const res = await conn.get(snapMesinAPI.liatTagMesin, query);
      if (!res.data) {
        throw e;
      }
      if (res.data.status) {
        commit("setTagMesin", res.data);
        return resulter.successResult();
      }
    } catch (e) {
      return resulter.errorResult(e);
    }
  },

  async tambahMesin({ commit, rootGetter }, payload) {
    try {
      let form = new FormData();
      form.append("id", payload.id);
      form.append("serial", payload.serial);
      form.append("id_outlet", payload.id_outlet);
      form.append("nama", payload.nama);
      form.append("jenis", payload.jenis);
      form.append("door", payload.door);
      form.append("nama_snap_tag", payload.nama_snap_tag);

      const res = await conn.post(
        snapMesinAPI.addMesin,
        form,
        conn.contentType.form,
        null
      );
      if (!res.data) {
        throw res;
      }
      if (res.data.status) {
        return resulter.successResult(res.data.msg, res.data.data);
      } else {
        return resulter.errorResult(res.data.msg);
      }
    } catch (e) {
      return resulter.errorResult(e);
    }
  },

  async cekIdMesin({ commit, rootGetter }, idMesin) {
    try {
      let query = {
        idsnap_mesin: idMesin,
      };
      const res = await conn.post(
        snapMesinAPI.cekIdMesin,
        null,
        conn.contentType.json,
        query
      );
      if (!res.data) {
        throw res;
      }
      if (res.data.status) {
        return resulter.successResult(res.data.msg);
      } else {
        return resulter.errorResult(res.data.msg);
      }
    } catch (e) {
      return resulter.errorResult(e);
    }
  },

  async updateMesin({ commit, rootGetter }, payload) {
    try {
      let query = {
        idsnap_mesin: payload.idsnap_mesin,
        idoutlet: payload.idoutlet,
      };
      let form = new FormData();
      form.append("nama", payload.input.nama);
      form.append("jenis", payload.input.jenis);
      if (payload.input.door === undefined) {
        form.append("door", 0);
      } else {
        form.append("door", payload.input.door);
      }
      form.append("snapTag", payload.input.tag);
      // for (let i = 0; i < payload.input.tag.length; i++) {
      //     form.append("snapTag", payload.input.tag[i])
      // }

      const res = await conn.post(
        snapMesinAPI.updateMesin,
        form,
        conn.contentType.form,
        query
      );
      if (!res.data) {
        throw res;
      }
      if (res.data.code === 200) {
        return resulter.successResult(res.data);
      } else {
        return resulter.errorResult(res.data);
      }
    } catch (e) {
      return resulter.errorResult(e);
    }
  },

  async deleteMesin({ commit, routeGetter }, queryParam) {
    try {
      let query = {
        idsnap_mesin: queryParam.idsnap_mesin,
        idoutlet: queryParam.idoutlet,
      };
      const res = await conn.post(
        snapMesinAPI.hapusMesin,
        null,
        conn.contentType.json,
        query
      );
      if (!res.data) {
        throw res;
      }
      if (res.data.code === 200) {
        return resulter.successResult(res.data.msg);
      } else {
        return resulter.errorResult(res.data.msg);
      }
    } catch (e) {
      return resulter.errorResult(e);
    }
  },

  async turnOnMesin({ commit, routeGetter }, payload) {
    try {
      let query = {
        idsnap_mesin: payload.idsnap_mesin,
      };
      let res = null;

      if (payload.menit && payload.menit !== "0") {
        let form = new FormData();
        form.append("menit", payload.menit);

        res = conn.post(
          snapMesinAPI.turnOnMesinTimer,
          form,
          conn.contentType.form,
          query
        );
      } else {
        res = conn.post(
          snapMesinAPI.turnOnMesin,
          null,
          conn.contentType.json,
          query
        );
      }

      if (!res.data) {
        throw res;
      }
      if (res.data.code === 200) {
        return resulter.successResult(res.data.msg);
      } else {
        return resulter.errorResult(res.data.msg);
      }
    } catch (e) {
      return resulter.errorResult(e);
    }
  },

  async turnOffMesin({ commit, routeGetter }, id) {
    try {
      let query = {
        idsnap_mesin: id,
      };

      const res = conn.post(
        snapMesinAPI.turnOffMesin,
        null,
        conn.contentType.json,
        query
      );
      if (!res.data) {
        throw res;
      }
      if (res.data.code === 200) {
        return resulter.successResult(res.data.msg);
      } else {
        return resulter.errorResult(res.data.msg);
      }
    } catch (e) {
      return resulter.errorResult(e);
    }
  },

  async fetchListMesinUrut({ commit, rootGetter }, idoutlet) {
    try {
      let query = {
        idoutlet: idoutlet,
      };
      const res = await conn.get(snapMesinAPI.listMesinUrut, query);
      if (!res.data) {
        throw e;
      }
      if (res.data.status) {
        commit("setListMesinUrut", res.data);
        return resulter.successResult();
      }
    } catch (e) {
      return resulter.errorResult(e);
    }
  },
  async updateMesinSorting({ commit, rootGetter }, payload) {
    try {

      const res = await conn.post(snapMesinAPI.updateMesinSorting + "?idoutlet=" + payload.idoutlet, payload.data);
      if (!res.data) {
        throw res;
      }
      if (res.data.code === 200) {
        return resulter.successResult(res.data);
      } else {
        return resulter.errorResult(res.data);
      }
    } catch (e) {
      return resulter.errorResult(e);
    }
  },

};

export default actions;
